import { Component, Output } from '@angular/core';
declare var bootstrap: any;
import { ActivatedRoute, Router } from '@angular/router';
import { ServiceLocatorService } from '@ncs/ncs-lib';
import { UiformBaseComponent } from '../uiform-base/uiform-base.component';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Editor, toHTML, Toolbar } from 'ngx-editor';
import { update } from 'lodash';
import * as QRCode from 'qrcode';
import { HttpResponse } from '@angular/common/http';
import { MatCheckboxChange } from '@angular/material/checkbox';
interface RowData {
  id: number;
  selected?: boolean;
  editing?: boolean;
  editingField?: string;
  _originalValue?: any;
  [key: string]: any;
}
@Component({
  selector: 'app-uiform-list',
  templateUrl: './uiform-list.component.html',
  styleUrls: ['./uiform-list.component.css'],
})
export class UiformListComponent extends UiformBaseComponent {
  public usecaseSchema: any = {};
  public entryform: any = {
    data: { id: 0 }, //form data
  };
  sortedField: string | null = null;
  sortOrder: 'ASC' | 'DESC' | null = null;

  read: number = 0;
  update: number = 0;
  isDelete: number = 0;
  create: number = 0;
  formId: any = 0;
  loadingAccess: boolean = true;
  @Output() override isUserFilter: number = 0;
  private _tokenAccessGranted: boolean = false;
  constructor(
    public override locator: ServiceLocatorService,
    public override route: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private router: Router,
  ) {
    super(locator, route);
    let _self = this;
    if (route.snapshot.paramMap.get('appId'))
      _self.appId = Number(route.snapshot.paramMap.get('appId'));

    if (route.snapshot.paramMap.get('usecaseId'))
      _self.usecaseId = Number(route.snapshot.paramMap.get('usecaseId'));

    if (route.snapshot.paramMap.get('uiformId'))
      _self.uiformId = Number(route.snapshot.paramMap.get('uiformId'));

    _self.locator.config
      .getProperty('endpoint.ui.forms')
      .then((property: string) => {
        _self.initApiEndpoint(property);
      });

    _self.locator.getPathVariable(route, function (params: any) {
      _self.usecaseId = locator.dataValidator.toInt(params['usecaseId']);
      _self.appId = locator.dataValidator.toInt(params['appId']);
      _self.uiformId = locator.dataValidator.toInt(params['uiformId']);
      _self.ngOnInit();
      _self.showSearchInputs = false;
    });

    const nav = this.router.getCurrentNavigation();
    if (nav?.extras?.state?.['tokenAccess'] === true) {
      this._tokenAccessGranted = true;
    }
  }

  override ngOnInit() {
    let _self = this;
    _self.filteredData = [];
    _self.read = 0;
    _self.update = 0;
    _self.isDelete = 0;
    _self.create = 0;
    _self.isUserFilter = 0;

    _self.checkUserAccess(_self.uiformId);
    if (_self.uiformId)
      this.get(_self.uiformId, function () {
        _self.usecaseId = _self.form.data.userstoryId;
        _self.formId = _self.form.data.id;
        _self.getUsecaseSchema(true, () => {
          _self.enabletag = _self.usecase?.tagenable || 0;
        });
      });
  }

  async checkUserAccess(uiformId: any) {
    let _self = this;
    if (!uiformId && uiformId < 0) {
      return;
    }

    if (_self._tokenAccessGranted) {
      _self.create = 1;
      _self.isDelete = 1;
      _self.read = 1;
      _self.update = 1;
      _self.isUserFilter = 0;
      _self.loadingAccess = false;
      return;
    }
    const keySuffix = localStorage.getItem('keySuffix');
    const appId = localStorage.getItem(keySuffix + 'appId');
    const applicationRoleId = localStorage.getItem(keySuffix + 'roleId');

    const searchParam = {
      applicationId: Number(appId),
      formId: Number(uiformId),
      applicationRoleId: Number(applicationRoleId),
    };

    _self.locator.config
      .getProperty('endpoint.application.role.usecase')
      .then((property: string) => {
        let url = property + '/search';
        this.locator.http.post(
          url,
          searchParam,
          async function (res: any, error: any) {
            if (error) {
              console.error('Server Error:' + error);
              return;
            }

            if (res.success) {
              let templist = res.result.data;
              if (templist.length > 0) {
                _self.create = templist[0]['create'];
                _self.isDelete = templist[0]['delete'];
                _self.read = templist[0]['read'];
                _self.update = templist[0]['update'];
                _self.isUserFilter = templist[0]?.userFilter;
                _self.loadingAccess = false;
              }
            }
          },
        );
      });
  }

  /**
   * get usecase records list
   */
  override search(callback?: any): void {
    let _self = this;
    _self.getUiformDataList();
  }

  sortTable(field: string): void {
    let _self = this;
    if (this.sortedField === field) {
      this.sortOrder = this.sortOrder === 'ASC' ? 'DESC' : 'ASC';
    } else {
      this.sortedField = field;
      this.sortOrder = 'ASC';
    }
    _self.form.searchParams['orderBy'] = this.sortedField;
    _self.form.searchParams['asc'] = this.sortOrder;
    _self.getUiformDataList();
  }

  override processData() {
    this.filteredData = [...this.usecaseData];
  }

  override onSearchReferenceValueChange(e: any, value: any) {
    let _self = this;
    this.searchValues[e.code] = isNaN(parseFloat(value))
      ? undefined
      : parseFloat(value);
    let target =
      this.usecase?.parentUsecaseDependency?.[e.primaryUsecase]?.code;

    while (target) {
      let id = _self.usecase['parentUsecases'][target].id;
      delete this.searchValues[id];
      target = this.usecase?.parentUsecaseDependency?.[target]?.code;
    }
    //Check Primary Usecase Dependency Filter
    if (
      _self.usecase !== undefined &&
      _self.usecase['parentUsecaseDependency'] !== undefined &&
      _self.usecase['parentUsecaseDependency'][e['primaryUsecase']] !==
        undefined
    ) {
      _self.primaryUsecaseDependencyFilter(
        _self.usecase['parentUsecaseDependency'][e['primaryUsecase']],
        value,
      );
    }
  }

  /***
   * primaryUsecaseDependencyFilter
   */
  primaryUsecaseDependencyFilter(data: any, val: any) {
    let _self = this;

    let key = val;
    let [appCode, codes] = (data['code'] ?? '').toString().split('.');

    let url =
      _self.locator.config.get('endpoint.api.v1') +
      '/' +
      appCode +
      '/' +
      codes +
      '/preloadData';
    let searchParams = {
      [data['id']]: parseFloat(val),
    };
    _self.locator.http.post(
      url,
      searchParams,
      function (res: any, error: boolean) {
        if (error) {
          _self.entryform['error'] = true;
          _self.entryform['message'] = error;
          return;
        }
        _self.form.preload[data['code']] = res.result[data['code']];
      },
    );
  }

  public getUiformDataList() {
    let _self = this;
    let list_key = 'uiform_listdata';
    if (list_key in localStorage) {
      const jsonData = localStorage.getItem(list_key);
      if (jsonData) {
        _self.usecaseData = JSON.parse(jsonData);
        _self.filteredData = [..._self.usecaseData];
        localStorage.removeItem(list_key);
        return;
      }
    }
    this.getUsecaseDataList();
  }

  resetSearch() {
    var _self = this;
    _self.searchValues = {};
    _self.form.pageNo = 0;
    _self.getUsecaseDataList();
    _self.form.searchParams = {};
  }

  /**
   * Filer list by usecase name
   */
  public searchItem: string = '';

  reSearch() {
    var _self = this;
    _self.form.pageNo = 0;
    _self.getUsecaseDataList();
  }

  /**
   *
   * @returns Filter useacases
   */
  public filterData(): any {
    let _self = this;
    return this.usecaseData.filter((item) =>
      // Check if any value in the object matches the search term
      Object.values(item).some((value: any) =>
        value.toString().toLowerCase().includes(_self.searchItem.toLowerCase()),
      ),
    );
  }

  filteredData: any[] = [];

  filterTable() {
    this.filteredData = this.usecaseData.filter((item) => {
      return Object.keys(this.searchValues).every((key) => {
        const searchValue = this.searchValues[key]?.toLowerCase();
        const itemValue = (item[key] as string | number | undefined)
          ?.toString()
          .toLowerCase();
        return !searchValue || itemValue?.includes(searchValue);
      });
    });
  }

  onDelete(id: any) {
    this.deleteUseCaseData(id, () => {
      this.getUsecaseDataList();
    });
  }

  onNew() {}

  onEdit(id: any) {
    this.forward('uiform/' + this.uiformId + '/' + id);
  }

  /**
   * Export data
   */
  public exportData() {
    let _self = this;
    let url = _self.urlRewrite(_self.apiurl + '/export');
    let searchData = _self.getSearchCriteria();
    // searchData['pageNo'] = _self.form.pageNo;
    _self.locator.http
      .getClient()
      .post(url, searchData, { responseType: 'blob' })
      .subscribe(
        (data: any) => {
          _self.downloadDataAsFile(data, 'export.csv');
        },
        (data: any) => {
          console.error(data);
        },
      );
  }

  /**
   * Export data in PDF
   */
  // public exportPDFData() {
  //   let _self = this;
  //   let url = _self.urlRewrite(_self.apiurl + '/pdf');
  //   //let endpoint = this.httpService.urlRewrite(url);
  //   _self.locator.http
  //     .getClient()
  //     .post(url,  _self.getSearchCriteria(), { responseType: 'blob' })
  //     .subscribe(
  //       (data: any) => {
  //         _self.downloadDataAsFile(data, 'export.pdf');
  //       },
  //       (data: any) => {
  //         console.error(data);
  //       }
  //     );
  // }

  // public exportPDFData() {
  //   console.log('Hello world : ');

  //   const url = this.urlRewrite(this.apiurl + '/pdflist');
  //   const payload = this.getSearchCriteria();

  //   console.log('URL:', url);
  //   console.log('Payload:', payload);

  //   this.locator.http
  //     .getClient()
  //     .post(url, payload)
  //     .subscribe(
  //       (response: any) => {
  //         console.log('PDF Response:', response);

  //         // Extract message (backend supports 2 formats)
  //         const message =
  //           response?.message ||
  //           response?.result?.message ||
  //           'Something went wrong';

  //         // Show message in UI (you are not using message service)
  //         this.form['message'] = message;
  //         this.form['error'] = !response?.success;

  //         if (!response.success) {
  //           // Failure case (show only message)
  //           console.warn('Export failed:', message);
  //           return;
  //         }

  //         // Success message
  //         console.log('PDF request saved successfully.');
  //       },

  //       (error: any) => {
  //         console.error('PDF Export Error:', error);

  //         // Extract message correctly from backend error
  //         const message =
  //           error?.error?.message ||
  //           error?.error?.result?.message ||
  //           'Server error, please try again.';

  //         this.form['message'] = message;
  //         this.form['error'] = true;
  //       }
  //     );
  // }

  public exportPDFDataEmail() {
    const url = this.urlRewrite(this.getAPIBaseUrl('pdflist'));

    console.log('url : ', url);

    const payload = this.getSearchCriteria();

    console.log('url : ', payload);

    payload['totalCount'] = this.formListRecord;

    this.locator.http
      .getClient()
      .post(url, payload, {
        responseType: 'blob',
        observe: 'response',
      })
      .subscribe({
        next: (response: HttpResponse<Blob>) => {
          const contentType = response.headers.get('content-type');

          // PDF response
          if (contentType && contentType.includes('application/pdf')) {
            const blob = new Blob([response.body!], {
              type: 'application/pdf',
            });
            const downloadUrl = window.URL.createObjectURL(blob);

            const a = document.createElement('a');
            a.href = downloadUrl;
            a.download = 'NcsIndore_Report.pdf';
            a.click();

            window.URL.revokeObjectURL(downloadUrl);
            return;
          }

          // JSON response (email flow)
          const reader = new FileReader();
          reader.onload = () => {
            const json = JSON.parse(reader.result as string);
            this.form['message'] = json.message;
            this.form['error'] = !json.success;
          };
          reader.readAsText(response.body!);
        },

        error: (error: any) => {
          console.error('PDF Export Error:', error);
          this.form['message'] = 'Server error, please try again.';
          this.form['error'] = true;
        },
      });
  }

  /**
   * Downalod data as file
   * @param data
   * @param fileName
   */
  public downloadDataAsFile(data: any, fileName: string) {
    //Create a dynamic link and download file
    let file = new window.Blob([data], { type: data.type });
    const downloadAncher = document.createElement('a');
    downloadAncher.style.display = 'none';
    const fileURL = URL.createObjectURL(file);
    downloadAncher.href = fileURL;
    downloadAncher.download = fileName;
    downloadAncher.click();
  }
  public showErrorModal: boolean = false;

  uploadResult = {
    uploadId: null as number | null,
    totalRows: 0,
    successRows: 0,
    errorRows: 0,
  };

  public onCsvFileUpload(event: any) {
    const fileObj = event.target.files[0];
    const _self = this;
    _self.form.error = false;
    _self.form.message = '';
    const url =
      _self.locator.config.get('endpoint.userstory') +
      '/importCSV/' +
      _self.usecaseId;
    const param = { id: this.form.data.id };
    this.locator.http.postMutipart(
      url,
      param,
      fileObj,
      function (res: any, error: any) {
        if (error) {
          alert(error);
          return;
        }
        _self.form.error = !res.success;
        if (res.success) {
          _self.form.message = 'File uploaded successfully';
          _self.uploadResult = {
            uploadId: res.result.uploadId || null,
            totalRows: res.result.totalRows || 0,
            successRows: res.result.successfulUploads || 0,
            errorRows: res.result.errorRows || 0,
          };
          const summaryModal = new bootstrap.Modal(
            document.getElementById('uploadSummaryModal'),
          );
          summaryModal.show();
          _self.search();
        } else {
          alert(res.message);
        }
      },
    );
  }
  /**
   * Export Sample data in CSV
   */
  public exportSampleData() {
    let _self = this;
    let url = _self.urlRewrite(_self.apiurl + '/exportSampleCSV');
    _self.locator.http
      .getClient()
      .post(url, {}, { responseType: 'blob' })
      .subscribe(
        (data: any) => {
          _self.downloadDataAsFile(data, 'export.csv');
        },
        (data: any) => {
          console.error(data);
        },
      );
  }

  getDescription(field: any) {
    if (field['description']) {
      return field['description'];
    }
    return field['label'];
  }

  viewMode: 'table' | 'card' = 'table'; // Default to table view
  toggleView(mode: 'table' | 'card') {
    this.viewMode = mode;
  }

  //tag

  inputValue: string = '';
  selectedTags: string[] = [];
  tagsList: string[] = [];
  filteredTagsList = [...this.tagsList];
  searchText = '';

  toggleTagSelection(tag: string, event: Event) {
    const inputElement = event.target as HTMLInputElement;
    const checked = inputElement.checked;

    if (checked) {
      if (!this.selectedTags.includes(tag)) {
        this.selectedTags.push(tag);
      }
    } else {
      this.selectedTags = this.selectedTags.filter((t) => t !== tag);
    }
  }

  // onTagCheckboxChange(tag: string, event: MatCheckboxChange): void {
  //   // ← changed
  //   console.log('Hello world i am here to understand where i am');

  //   if (event.checked) {
  //     // ← removed event.target, use event.checked directly
  //     if (!this.selectedTags.includes(tag)) {
  //       this.selectedTags.push(tag);
  //     }
  //   } else {
  //     this.selectedTags = this.selectedTags.filter((t) => t !== tag);
  //   }

  //   const payload = {
  //     tag: this.selectedTags.join(', '),
  //     id: this.recordData?.id,
  //   };

  //   const url = this.urlRewrite(
  //     this.getAPIBaseUrl(this.form.data.code + '/saveForm'),
  //   );

  //   this.locator.http.post(url, payload, (res: any, error: boolean) => {
  //     if (error) {
  //       alert('Server Error:' + error);
  //       return;
  //     }

  //     this.entryform['error'] = !res.success;
  //     this.entryform['message'] = res.message;
  //     this.entryform['inputerror'] = res.result?.inputerror;
  //     this.entryform['inputerrormsg'] = res.result?.inputerror
  //       ? Object.values(res.result.inputerror).join(', ')
  //       : '';

  //     if (res.success) {
  //       this.entryform['data']['id'] = res.result['data']['id'];
  //       this.textData = res.result.data.tag ?? '';
  //       this.tagListData = this.textData
  //         .split(',')
  //         .map((t: string) => t.trim())
  //         .filter((t: string) => t !== '');
  //       this.selectedTags = [...this.tagListData];

  //       if (this.recordData) {
  //         this.recordData['tag'] = this.textData;
  //       }

  //       this.id = res.result['data']['id'];
  //       this.search();
  //     }
  //   });
  // }

  onTagCheckboxChange(tag: string, event: MatCheckboxChange): void {
    if (event.checked) {
      if (!this.selectedTags.includes(tag)) {
        this.selectedTags.push(tag);
      }
    } else {
      this.selectedTags = this.selectedTags.filter((t) => t !== tag);
    }

    const filteredData: any = JSON.parse(JSON.stringify(this.recordData));

    // ✅ When no tags selected, send empty string explicitly
    filteredData['tag'] =
      this.selectedTags.length > 0 ? this.selectedTags.join(', ') : '';

    const dateTimeCodes = this.usecaseAttributes
      .filter((item: any) =>
        ['dateandtime', 'idate', 'itime'].includes(item.type),
      )
      .map((item: any) => item.code);

    dateTimeCodes.forEach((code: string) => {
      const value = filteredData[code];
      if (typeof value === 'string') {
        filteredData[code] = new Date(value).toISOString();
      }
    });

    // ✅ Remove null/empty keys — but KEEP tag even if empty
    Object.keys(filteredData).forEach((key) => {
      if (key === 'tag') return; // ← don't delete tag field even if empty
      if (filteredData[key] === '' || filteredData[key] === null) {
        delete filteredData[key];
      }
    });

    console.log('Full Tag Payload:', filteredData);

    const url = this.urlRewrite(
      this.getAPIBaseUrl(this.form.data.code + '/saveForm'),
    );

    this.locator.http.post(url, filteredData, (res: any, error: boolean) => {
      if (error) {
        alert('Server Error:' + error);
        return;
      }

      this.entryform['error'] = !res.success;
      this.entryform['message'] = res.message;
      this.entryform['inputerror'] = res.result?.inputerror ?? null;
      this.entryform['inputerrormsg'] = res.result?.inputerror
        ? Object.values(res.result.inputerror).join(', ')
        : '';

      if (!res.success) return;

        this.entryform['data']['id'] = res.result['data']['id'];
      this.id = res.result['data']['id'];

        this.textData = res.result.data.tag ?? '';
        this.tagListData = this.textData
          .split(',')
          .map((t: string) => t.trim())
          .filter((t: string) => t !== '');
        this.selectedTags = [...this.tagListData];

        if (this.recordData) {
          this.recordData['tag'] = this.textData;
        }

      this.tagListData.forEach((t: string) => {
        if (!this.tagsList.includes(t)) {
          this.tagsList.push(t);
        }
      });
      this.filteredTagsList = [...this.tagsList];

        this.search();
    });
  }

  // Handle user input in the input field
  onUserInput(event: any) {
    this.searchText = event.target.value.toLowerCase().trim();

    // Show filtered only if input is not empty
    if (this.searchText) {
      this.filteredTagsList = this.tagsList.filter((tag) =>
        tag.toLowerCase().includes(this.searchText),
      );
    } else {
      this.filteredTagsList = [...this.tagsList]; // show all tags
    }
  }

  // Handle selection from the dropdown
  onSelectChange(event: any) {
    const selectedValue = event.target.value;
    if (selectedValue && !this.selectedTags.includes(selectedValue)) {
      this.selectedTags.push(selectedValue.trim());
    }
    this.updateInputField();
  }

  addTags() {
    const newTags = this.inputValue
      .split(',')
      .map((tag) => tag.trim())
      .filter((tag) => tag !== '');
    // Add new tags to the list if they don't exist
    newTags.forEach((tag) => {
      if (!this.tagsList.includes(tag)) {
        this.tagsList.push(tag);
      }
    });
    // Clear input field after adding
    this.inputValue = '';
    this.updateInputField();
  }

  updateInputField() {
    this.selectedTags = this.selectedTags.filter((item) => item !== undefined);
    const selectedTags = this.selectedTags.filter((tag) => tag.trim() !== '');
    this.inputValue = selectedTags.join(', ');
  }

  // Remove the last added tag
  public recordData: any = {};
  public addIndex: any;
  public recordCode: any;
  public textData: any;
  tagListData: any;

  allAttribute(recordData: any, addIndex: any) {
    this.searchText = '';

    // Step 1: Extract all tags from usecaseAttributes
    this.usecaseAttributes?.forEach((item: any) => {
      if (item.type === 'tag') {
        this.tagsList = item.values.filter((tag: string) => tag.trim() !== '');
      }
    });

    // Step 2: Prepare selected tags (from recordData['tag']), removing blanks
    this.textData = recordData['tag'];
    this.tagListData =
      this.textData
        ?.split(',')
        .map((t: string) => t.trim())
        .filter((t: string) => t !== '') || [];

    this.selectedTags = [...this.tagListData];

    // Step 3: Merge tags for checkbox list, still avoiding blanks
    this.filteredTagsList = [
      ...new Set([...this.selectedTags, ...this.tagsList]),
    ].filter((tag: string) => tag.trim() !== '');

    this.inputValue = '';
    this.recordData = recordData;
    this.addIndex = addIndex;

    this.getUsecaseDtaa1();

    const hasTags = this.usecaseAttributes?.some(
      (item: any) => item.type === 'tag',
    );
    if (!hasTags) {
      const payload = {
        label: 'tag',
        type: 'tag',
        userstoryId: this.usecaseId,
        values: [],
      };
      const url =
        this.locator.config.get('endpoint.userstory.attributes') + '/save';
      this.locator.http.post(url, payload, (res: any, error: boolean) => {
        if (error) {
          alert('Server Error: ' + error);
          return;
        }
        this.getUsecaseDtaa1();
      });
    }
  }

  getUsecaseDtaa1() {
    let _self = this;
    let attrUrl =
      _self.locator.config.get('endpoint.userstory.attributes') +
      '/list/' +
      _self.usecaseId;
    if (
      _self.usecaseId != 0 &&
      _self.usecaseId != null &&
      _self.usecaseId != undefined
    ) {
      _self.locator.http.get(attrUrl, function (res: any, error: boolean) {
        if (error) {
          alert('Server Error:' + error);
          return;
        }
        _self.usecaseAttributes = res.result.data;
        const tagItem = _self.usecaseAttributes?.find(
          (item: any) => item.type === 'tag',
        );
        if (tagItem) {
          _self.tagsList = tagItem.values;
        }
      });
    }
  }

  // getCleanTag(tag: string | null | undefined): string {
  //   if (!tag) return 'Add Tags';
  //   return tag.replace(/^,\s*/, ''); // Removes leading comma + spaces
  // }

  getCleanTag(tag: any): string {
    // Return default if not a string
    if (typeof tag !== 'string') {
      return 'Add Tags';
    }

    // Trim the tag to remove leading/trailing whitespace
    const cleanedTag = tag.trim();

    // If the cleaned tag is empty after trimming
    if (cleanedTag === '') {
      return 'Add Tags';
    }
    return cleanedTag.replace(/^,+\s*/, '');
  }

  code = '';
  // saveTags() {
  //   if (!this.recordData) return;

  //   // Step 1: Add new tags to master list
  //   const newTags = this.inputValue
  //     .split(',')
  //     .map((t: string) => t.trim())
  //     .filter((t: string) => t !== '');

  //   console.log('newTags : ' + newTags);

  //   newTags.forEach((tag) => {
  //     if (!this.tagsList.includes(tag)) {
  //       this.tagsList.push(tag);
  //     }
  //     if (!this.selectedTags.includes(tag)) {
  //       this.selectedTags.push(tag);
  //     }
  //   });

  //   this.filteredTagsList = [...this.tagsList];

  //   console.log('Filter data : ' + this.filterAttributes);

  //   // Step 2: Update row tag locally
  //   const finalTags = Array.from(new Set(this.selectedTags));
  //   this.recordData.tag = finalTags.join(',');

  //   console.log('finalTags : ', finalTags);

  //   // Step 3: Save to backend
  //   const url = this.urlRewrite(
  //     this.getAPIBaseUrl(this.form.data.code + '/saveForm'),
  //   );

  //   // ✅ send complete object
  //   const payload = { ...this.recordData };

  //   console.log('Full Payload:', payload);

  //   this.locator.http.post(url, payload, (res: any, error: boolean) => {
  //     console.log('Backend response:', res, 'Error flag:', error); // ✅ Step 7

  //     if (error || !res.success) {
  //       alert('Server Error');
  //       return;
  //     }

  //     // Update master tag attribute in backend
  //     const tagAttr = this.usecaseAttributes.find(
  //       (item: any) => item.type === 'tag',
  //     );

  //     if (tagAttr) {
  //       tagAttr.values = [...this.tagsList];

  //       const attrUrl =
  //         this.locator.config.get('endpoint.userstory.attributes') + '/save';

  //       this.locator.http.post(attrUrl, tagAttr, () => {});
  //     }
  //     console.log('Input value:', this.inputValue);
  //     console.log('selectedTags before save:', this.selectedTags);
  //     console.log('tagsList before save:', this.tagsList);
  //     this.search(); // refresh table
  //   });

  //   this.inputValue = '';
  // }

  saveTags() {
    if (!this.recordData) return;

    // Step 1: Add new tags to master list
    const newTags = this.inputValue
      .split(',')
      .map((t: string) => t.trim())
      .filter((t: string) => t !== '');

    newTags.forEach((tag) => {
      if (!this.tagsList.includes(tag)) {
        this.tagsList.push(tag);
      }
      if (!this.selectedTags.includes(tag)) {
        this.selectedTags.push(tag);
      }
    });

    this.filteredTagsList = [...this.tagsList];

    // Step 2: Update row tag locally
    const finalTags = Array.from(new Set(this.selectedTags));
    this.recordData.tag = finalTags.join(',');

    // Step 3: Build filtered payload (same as saveUiformData)
    const filteredData = JSON.parse(JSON.stringify(this.recordData));
    const entryformLabels = Object.keys(filteredData);

    // Handle dateandtime fields
    const dateAndTime = this.usecaseAttributes.filter(
      (item: any) => item.type === 'dateandtime',
    );
    dateAndTime.forEach((item: any) => {
      if (filteredData[item.code]) {
        filteredData[item.code] = new Date(
          filteredData[item.code],
        ).toISOString();
      }
    });

    // Handle itime fields
    const timeAttributes = this.usecaseAttributes.filter(
      (item: any) => item.type === 'itime',
    );
    timeAttributes.forEach((item: any) => {
      if (entryformLabels?.includes(item.code)) {
        let value = filteredData[item.code];
        if (value && value.length === 5) {
          value = `1970-01-01T${value}:00`;
        }
        filteredData[item.code] = new Date(value).toISOString();
      }
    });

    // Handle idate fields
    const dateAttributes = this.usecaseAttributes.filter(
      (item: any) => item.type === 'idate',
    );
    dateAttributes.forEach((item: any) => {
      if (filteredData[item.code]) {
        filteredData[item.code] = new Date(
          filteredData[item.code],
        ).toISOString();
      }
    });

    // Step 4: Save to backend
    const url = this.urlRewrite(
      this.getAPIBaseUrl(this.form.data.code + '/saveForm'),
    );

    this.locator.http.post(url, filteredData, (res: any, error: boolean) => {
      if (error || !res.success) {
        alert('Server Error');
        return;
      }

      // Update master tag attribute in backend
      const tagAttr = this.usecaseAttributes.find(
        (item: any) => item.type === 'tag',
      );

      if (tagAttr) {
        tagAttr.values = [...this.tagsList];

        const attrUrl =
          this.locator.config.get('endpoint.userstory.attributes') + '/save';

        this.locator.http.post(attrUrl, tagAttr, () => {});
      }

      this.search(); // refresh table
    });

    this.inputValue = '';
  }

  enabletag = 0;
  removeTag(index: number) {
    let _self = this;
    this.tagListData.splice(index, 1);
    this.textData = this.tagListData?.map((tag: any) => tag.trim()).join(', ');
    let url = _self.urlRewrite(
      _self.getAPIBaseUrl(_self.form.data.code + '/saveForm'),
    );

    const payload = {
      tag: this.textData,
      id: _self.recordData?.id,
    };
    _self.locator.http.post(url, payload, function (res: any, error: boolean) {
      if (error) {
        alert('Server Error:' + error);
        return;
      }
      _self.entryform['error'] = !res.success;
      _self.entryform['message'] = res.message;
      _self.entryform['inputerror'] = res.result?.inputerror;

      if (res.result?.inputerror) {
        _self.entryform['inputerrormsg'] = Object.values(
          res.result?.inputerror || {},
        ).join(', ');
      } else {
        _self.entryform['inputerrormsg'] = Object.values(
          res.result?.inputerror || {},
        ).join(', ');
      }
      if (res.success) {
        _self.entryform['data']['id'] = res.result['data']['id'];
        _self.textData = res?.result?.data?.tag;
        _self.tagListData = _self.textData?.split(',');
        _self.id = res.result['data']['id'];
        _self.search();
      }
    });

    _self.inputValue = '';
    _self.selectedTags = [];
  }

  masterSelected: boolean = false;
  selectAll() {
    this.filteredData.forEach((item: any) => {
      item.selected = this.masterSelected;
    });
  }

  checkIfAllSelected() {
    this.masterSelected = this.filteredData.every((item: any) => item.selected);
  }
  Deleteall() {
    const selectedItems = this.filteredData.filter((item) => item.selected);

    this.deleteUseSelectedUseCase(selectedItems, (deletedIds: any[]) => {
      // Only remove items from UI if they were successfully deleted
      this.filteredData = this.filteredData.filter(
        (item) => !deletedIds.includes(item.id),
      );
      this.masterSelected = false;

      // Refresh list or do any additional processing
      this.getUsecaseDataList();
    });
  }

  goToForm() {
    const fields = this.form.data['fields'];
    if (!fields || fields.length === 0) {
      alert('Add at least one input field to Add data');
      return;
    }
    this.checkAddOnRule();
  }
  checkAddOnRule() {
    let _self = this;
    const url = _self.urlRewrite(_self.getAPIBaseUrl('fetchRule'));
    _self.locator.http.post(
      url,
      { formId: _self.formId },
      function (res: any, error: boolean) {
        if (error) {
          alert('Server Error: ' + error);
          return;
        }
        const updatedFormID = res?.result?.data?.updatedFormID;
        if (updatedFormID && updatedFormID !== '') {
          _self.onEdit(updatedFormID);
        } else {
          _self.forward('/uiform/' + _self.form.data.id);
        }
      },
    );
  }

  getSanitizedHtml(html: any): SafeHtml {
    if (html && typeof html === 'object' && html.type === 'doc') {
      try {
        html = toHTML(html); // <-- ✅ Convert to real HTML
      } catch (err) {
        html = '';
      }
    }
    if (typeof html !== 'string') {
      html = String(html ?? '');
    }
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  editors: { [key: string]: Editor } = {};
  activeEditorKey: string | null = null;

  toolbar: Toolbar = [
    ['bold', 'italic'],
    ['underline', 'strike'],
    ['code', 'blockquote'],
    ['ordered_list', 'bullet_list'],
    [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
    ['link', 'image'],
    ['text_color', 'background_color'],
    ['align_left', 'align_center', 'align_right', 'align_justify'],
  ];

  // Get or create editor instance
  getEditorInstance(rowId: number, fieldCode: string): Editor {
    const editorKey = `${rowId}_${fieldCode}`;

    if (!this.editors[editorKey]) {
      this.editors[editorKey] = new Editor({
        content: '',
        history: true,
        keyboardShortcuts: true,
      });
    }

    this.activeEditorKey = editorKey;
    return this.editors[editorKey];
  }

  startEditing(row: RowData, field: any) {
    if (this.form.data.readOnly === 'true') return;

    const nonEditableTypes = [
      'file',
      'doc',
      'location',
      'object',
      'map',
      'expression',
    ];
    if (nonEditableTypes.includes(field.type)) return;

    const data = this.usecaseAttributes.find(
      (item: any) => item.code === field.code,
    );
    if (data?.readOnly) {
      alert("This field is read-only. You can't modify it.");
      return;
    }

    row.editing = true;
    row.editingField = field.code;

    // Store original value - strip HTML if not using editor
    row._originalValue =
      typeof row[field.code] === 'object'
        ? JSON.parse(JSON.stringify(row[field.code]))
        : row[field.code];

    // Initialize editor content
    if (field.type === 'textarea' && field.enableEditor == 1) {
      const editor = this.getEditorInstance(row.id, field.code);
      editor.setContent(row[field.code] || '');
    }
  }

  // Handle editor content changes
  onEditorContentChange(rowId: number, fieldCode: string, content: string) {
    const editorKey = `${rowId}_${fieldCode}`;
    if (this.editors[editorKey]) {
      const row = this.filteredData.find((e) => e.id === rowId);
      if (row) {
        row[fieldCode] = content;
      }
    }
  }

  // Get current editor content as HTML
  getCurrentEditorContent(rowId: number, fieldCode: string): string {
    const editorKey = `${rowId}_${fieldCode}`;
    if (this.editors[editorKey]) {
      return this.editors[editorKey].view.dom.innerHTML;
    }
    return '';
  }

  stopEditing(row: RowData, field: any) {
    if (!row.editing) return;

    const fieldCode = row.editingField;
    if (!fieldCode) return;

    // Get final content
    if (field.type === 'textarea') {
      if (field.enableEditor == 1) {
        // HTML Editor: Get raw HTML content
        row[fieldCode] = this.getCurrentEditorContent(row.id, fieldCode);
      } else {
        // Normal Textarea: Ensure we're working with plain text
        row[fieldCode] = this.removeHTMLTags(row[fieldCode]);
      }
    }

    // Prepare values for comparison
    const currentValue = row[fieldCode];
    const originalValue =
      field.enableEditor == 1
        ? row._originalValue
        : this.removeHTMLTags(row._originalValue);

    if (currentValue !== originalValue) {
      this.saveChanges(row, fieldCode, field);
    } else {
      this.cancelEditing(row);
    }
  }
  handleTextareaChange(rowId: number, fieldCode: string, value: string) {
    const row = this.filteredData.find((e) => e.id === rowId);
    if (row) {
      row[fieldCode] = value;
    }
  }
  // Cancel editing and revert changes
  cancelEditing(row: RowData) {
    if (row.editingField) {
      row[row.editingField] = row._originalValue;
    }
    row.editing = false;
    row.editingField = undefined;

    // Clean up active editor
    if (this.activeEditorKey) {
      this.destroyEditor(this.activeEditorKey);
      this.activeEditorKey = null;
    }
  }

  // Save to backend
  saveChanges(row: RowData, fieldCode: string, field: any) {
    const payload: any = {
      id: row.id,
      [fieldCode]:
        field.type === 'boolean' ? Number(row[fieldCode]) : row[fieldCode],
    };

    const url = this.urlRewrite(
      this.getAPIBaseUrl(this.form.data.code + '/saveForm'),
    );

    this.locator.http.post(url, payload, (res: any, error: boolean) => {
      if (error || !res?.success) {
        // Initialize an error message string
        let errorMessage = 'Failed to save changes. Please try again.';

        // If there are server-side input errors, append them to the error message
        if (res?.result?.inputerror) {
          const inputErrors = res.result.inputerror;

          // Check if there's a 'key' error message and use it as a main error message
          if (inputErrors['key']) {
            errorMessage = inputErrors['key'];
          } else {
            // Collect all error messages in inputerror and format them for display
            const errorMessages = Object.values(inputErrors).join('\n');
            errorMessage += `${errorMessages}`;
          }
        }
        row[fieldCode] = row._originalValue;
        // Display the error message in an alert
        alert(errorMessage);
      } else {
        row._originalValue = row[fieldCode]; // Update original value
      }

      // Clean up
      if (this.activeEditorKey) {
        this.destroyEditor(this.activeEditorKey);
        this.activeEditorKey = null;
      }

      row.editing = false;
      row.editingField = undefined;
    });
  }

  // Clean up editor instance
  destroyEditor(editorKey: string) {
    if (this.editors[editorKey]) {
      this.editors[editorKey].destroy();
      delete this.editors[editorKey];
    }
  }

  removeHTMLTags(html: string): string {
    if (!html) return '';
    const div = document.createElement('div'); // Temporary element banayenge
    div.innerHTML = html; // HTML inject karenge
    return div.textContent || div.innerText || ''; // Sirf text milega, no tags
  }

  getPreloadedLabel(at: any, selectedId: any): string {
    const options = this.form?.preload?.[at.primaryUsecase];
    if (!options) return '';

    const match = options.find((opt: any) => opt.id == selectedId);
    return match?._val || '';
  }
  getString1(value: string, type: string, timeType?: string): string {
    if (type === 'time' && value) {
      const [hours, minutes] = value.split(':').map(Number);
      if (timeType === '12') {
        const hour12 = hours % 12 || 12;
        const ampm = hours < 12 ? 'AM' : 'PM';
        return `${hour12}:${minutes.toString().padStart(2, '0')} ${ampm}`;
      }
      // Default is 24-hour
      return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
    }

    return value; // for other types
  }

  getStringitime(value: string, type: string, timeType?: string): string {
    if (type === 'itime' && value) {
      const d = new Date(value);
      let hours = d.getHours();
      const minutes = d.getMinutes().toString().padStart(2, '0');

      if (timeType === '12') {
        const hour12 = hours % 12 || 12;
        const ampm = hours < 12 ? 'AM' : 'PM';
        return `${hour12}:${minutes} ${ampm}`;
      }
      return `${hours.toString().padStart(2, '0')}:${minutes}`;
    }
    return value;
  }

  getLocationObject(value: any): { lat: number; lng: number } | null {
    if (!value) return null;
    if (typeof value === 'string') {
      try {
        const cleaned = value
          .replace(/lat\s*:\s*/i, '"lat":')
          .replace(/lng\s*:\s*/i, '"lng":')
          .replace(/'/g, '"');
        return JSON.parse(cleaned);
      } catch (e) {
        console.error('Invalid location string:', value);
        return null;
      }
    }

    if (typeof value === 'object' && value.lat && value.lng) {
      return value;
    }
    return null;
  }

  getFilteredData(data: any[]) {
    return data;
  }

  onSearchReferenceValueChange1(e: any, value: any) {
    if (typeof value === 'object' && value !== null) {
      this.searchValues[e.code] =
        typeof value.id === 'number' ? Number(value.id) : String(value.id);
    } else {
      this.searchValues[e.code] = value ?? undefined;
    }
  }
  compareFn = (item1: any, item2: any) => {
    return item1 == item2;
  };
  // Component TS
  filterFn = (term: string, item: any) => {
    if (!term) return true;
    term = term.toLowerCase();
    return item._val?.toLowerCase().includes(term);
  };

  openCodeInNewTab(type: string, value: string) {
    if (type === 'qr') {
      QRCode.toDataURL(value, { width: 200 }, (err, url) => {
        if (err) {
          console.error(err);
          return;
        }
        const win = window.open();
        win!.document.write(`
        <html>
          <head><title>QR Code</title></head>
          <body style="display: flex; align-items: center; justify-content: center; height: 100vh;">
            <img src="${url}" alt="QR Code">
          </body>
        </html>
      `);
      });
    } else if (type === 'bar') {
      const win = window.open();
      win!.document.write(`
      <html>
        <head><title>Barcode</title></head>
        <body style="display: flex; align-items: center; justify-content: center; height: 100vh;">
          <svg id="barcode"></svg>
          <script src="https://cdn.jsdelivr.net/npm/jsbarcode@3.11.5/dist/JsBarcode.all.min.js"></script>
          <script>
            JsBarcode("#barcode", "${value}", {format: "CODE128", width:2, height:100, displayValue: true});
          </script>
        </body>
      </html>
    `);
    }
  }

  getAppDocThumbnail(skey: number) {
    let _self = this;
    let keySuffix = _self.locator.config.get('CONTEXT_PATH') + '-';
    let appLogoId = localStorage.getItem(keySuffix + 'appLogoId');
    if (!skey) {
      if (appLogoId) {
        skey = Number(appLogoId);
      } else {
        skey = 0;
      }
    }
    let docAPI = this.locator.config.get('DOC_API');
    let url = docAPI + 'th/' + skey + '?t=' + this.imageTimestamp;

    return url;
  }

  /**
   * Get application doc
   * @param skey
   */
  getAppDoc(skey: number) {
    let _self = this;
    let keySuffix = _self.locator.config.get('CONTEXT_PATH') + '-';
    let appLogoId = localStorage.getItem(keySuffix + 'appLogoId');
    if (!skey) {
      if (appLogoId) {
        skey = Number(appLogoId);
      } else {
        skey = 0;
      }
    }
    return _self.getDoc(skey);
  }

  selectedEntry: any = null;

  openViewModal(entry: any) {
    this.selectedEntry = entry;

    const modal = new bootstrap.Modal(
      document.getElementById('viewDetailsModal'),
    );
    modal.show();
  }

  //--------------------print option ---------------------//

  printModal(): void {
    console.log('hello world this is print method before return ...');
    const printContents = document.getElementById('printableArea')?.innerHTML;
    if (!printContents) return;

    console.log('hello world this is print method');

    const win = window.open('', '_blank', 'width=800,height=600');
    win?.document.write(`
    <html>
      <head>
        <title>${this.form.data['title']}</title>
        <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css">
        <style>
          body { font-family: Arial, sans-serif; padding: 20px; }
          table { width: 100%; border-collapse: collapse; }
          th, td { border: 1px solid #dee2e6; padding: 8px 12px; }
          th { background-color: #f8f9fa; }
          img { max-width: 80px; }
          @media print { body { padding: 0; } }
        </style>
      </head>
      <body onload="window.print(); window.close();">
        <h5 style="margin-bottom:16px;">${this.form.data['title']}</h5>
        ${printContents}
      </body>
    </html>
  `);
    win?.document.close();
  }

  viewErrorDetails() {
    const modal = document.getElementById('uploadSummaryModal');
    const bsModal = (window as any).bootstrap.Modal.getInstance(modal);
    bsModal?.hide();
    this.router.navigate([
      '/upload-logs',
      this.usecaseId,
      this.uploadResult.uploadId,
    ]);
  }
  hidePassword = true;
}
